import { render, staticRenderFns } from "./DispatchConfigForm.vue?vue&type=template&id=5baf6718&"
import script from "./DispatchConfigForm.vue?vue&type=script&lang=js&"
export * from "./DispatchConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports